import React, { useEffect } from "react";
import AddBankAccountForm from "@components/AddBankAccountForm";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";
import { SET_OPEN_ADD_BANK_ACCT_MODAL } from "@constants/achActionTypes";
import styled from "@emotion/styled";
import classNames from "classnames";

const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 109;
  background-color: rgba(31, 32, 33, 0.8);

  @media (max-height: 700px), (max-width: 420px) {
    position: absolute;
    height: 100%;
  }
`;

const Container = styled.div`
  width: 579px;
  height: auto;
  border-radius: 30px;
  background-color: #f8f8f8;
  margin: 0 auto;
  margin-top: 100px;

  @media (max-height: 900px) {
    margin-top: 63px;
  }
  @media (max-height: 815px) {
    margin-top: 45px;
  }
  @media (max-height: 735px) {
    margin-top: 15px;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #9b9b9b;
  align-self: flex-start;
  padding-top: 20px;
  padding-right: 26px;
  padding-left: 26px;

  @media (max-height: 600px) {
    padding-right: 20px;
    padding-top: 20px;
  }

  @media (max-width: 450px) {
    padding-right: 20px;
  }
`;

const CloseDivImage = styled.img`
  width: 17px;
`;

const CloseSpan = styled.span`
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 464px;
  padding-bottom: 38px;
  text-align: left;
  margin-top: -10px;

  @media (max-height: 815px) {
    margin-top: -12px;
  }

  @media (max-width: 600px) {
    width: 90%;
  }
  @media (max-width: 415px) {
    margin-top: 10px;
  }
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin: 0 auto;
  margin-bottom: 20px;

  @media (max-height: 815px) {
    font-size: 28px;
  }

  @media (max-width: 475px) {
    font-size: 24px;
  }
`;

const AddBankAccountModal = ({ showAddBankAccountModal, hideModal }) => {
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.scrollTo(0, 0);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      showAddBankAccountModal &&
      window.innerHeight > 700 &&
      window.innerWidth > 420
    ) {
      document.body.style.overflow = "hidden";
    }
    return () => (document.body.style.overflow = "initial");
  }, [showAddBankAccountModal]);

  const handleResize = () => {
    if (
      showAddBankAccountModal &&
      window.innerHeight > 700 &&
      window.innerWidth > 420
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "initial";
    }
  };

  const closeModal = () => {
    hideModal();
  };

  return (
    <PopUpContainer className={classNames("animated", "fast", "fadeInUp")}>
      <Container onClick={e => e.stopPropagation()}>
        <CloseDiv className="mar-t-10">
          <CloseSpan onClick={closeModal}>
            <CloseDivImage
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              aria-hidden="true"
              alt="close button"
            />
          </CloseSpan>
        </CloseDiv>
        <Content>
          <Header>New Bank Account</Header>

          <AddBankAccountForm />
        </Content>
      </Container>
    </PopUpContainer>
  );
};

export default connect(
  state => ({
    showAddBankAccountModal: state.ach.showAddBankAccountModal
  }),
  dispatch => ({
    hideModal: () =>
      dispatch(defaultAction(SET_OPEN_ADD_BANK_ACCT_MODAL, false))
  })
)(AddBankAccountModal);
